import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectBaseFullBathCost, selectFullBathCost } from './costSelectors/selectFullBathCost.ts';
import { selectBaseHalfBathCost, selectHalfBathCost } from './costSelectors/selectHalfBathCost.ts';
import {
  selectBaseMainStructureCost,
  selectMainStructureCost,
} from './costSelectors/selectMainStructureCost.ts';

const calculateGlaAndBathCostNew = (
  mainStructureCost: AloftPrice | undefined,
  fullBaths: AloftPrice | undefined,
  halfBaths: AloftPrice | undefined,
) => {
  if (isUndefined(mainStructureCost)) {
    return undefined;
  }

  return [mainStructureCost, fullBaths, halfBaths].reduce(
    (acc: AloftPrice, curr) => acc.add(curr),
    AloftPrice.zero,
  );
};

export const selectGlaAndBathCostNew = createSelector(
  [selectMainStructureCost, selectFullBathCost, selectHalfBathCost],
  calculateGlaAndBathCostNew,
);

export const selectBaseGlaAndBathCostNew = createSelector(
  [selectBaseMainStructureCost, selectBaseFullBathCost, selectBaseHalfBathCost],
  calculateGlaAndBathCostNew,
);
